export const BlobErrorResponse = async(error:any):Promise<string> => {
    const errorResponse = JSON.parse(await error.response.data.text())
    if (errorResponse.message)
        return errorResponse.message
    else
        return errorResponse.error
}